/**
 * Whether PGM Progress Surfaces should hide next-level purchase /
 * membership-election Apply CTAs while Acceptable Progress Termination
 * still blocks advancement.
 *
 * Curriculum (default): only suppress when standing is Reapply-Gated
 * (`showReapplyPathOffer`). Progress-Privileged Curriculum CTAs stay intact.
 *
 * Journey (`standingScoped: true`): suppress whenever standing blocks next-
 * level purchase (Progress-Privileged or Reapply-Gated). Pass this only from
 * Journey callers.
 */
export function shouldSuppressAdvancementCtas({
  standing,
  standingScoped = false,
}) {
  if (standingScoped) {
    return standing?.allowNextLevelPurchase === false
  }

  return !!standing?.showReapplyPathOffer
}

/**
 * Terminated GPTP / Curriculum APT copy while Progress-Privileged or
 * Reapply-Gated.
 */
export function shouldUseTerminatedGptpCopy({ standing }) {
  return !!standing?.showProgressStandingNotice
}

const CURRICULUM_REAPPLY_CTA_STATUSES = new Set(["open", "denied"])

/**
 * Display primary CTA as Reapply when terminated and current PGM Level has been completed
 */
export function shouldShowCurriculumReapplyCta({ standing, reapplyStatus }) {
  return (
    !!standing?.showReapplyPathOffer &&
    CURRICULUM_REAPPLY_CTA_STATUSES.has(reapplyStatus)
  )
}
